import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SelectionId } from 'src_common/common/websocket2/id/WebsocketId';
import {
    SelectionWrapper,
    CellRunner,
} from 'src/domains/sportsbook/webview/components/raceBoxSelection/heroWidget/HeroRaceBoxSelection.style';
import { RaceBoxSilkAndTrap } from 'src/domains/sportsbook/webview/components/raceBoxSelection/WidgetSilkAndTrap';
import { JockeyAndTrainerDetails } from 'src/domains/sportsbook/webview/components/raceSummary/templates/runnerInfo/JockeyAndTrainerDetails';

interface PropsType {
    selectionId: SelectionId;
}

export const HeroRaceBoxSelection = observer('RaceBoxSelection', ({ selectionId }: PropsType) => {
    const selectionModel = selectionId.getModel();
    if (selectionModel === null) {
        return null;
    }

    const marketModel = selectionModel.marketId2.getModel();
    if (marketModel === null) {
        return null;
    }

    const isUnnamedFavourite = selectionModel.templateId === 'unnamed-favourite';

    const isParticipantDescHidden = isUnnamedFavourite || marketModel.isOutright;

    return (
        <>
            <CellRunner>
                <RaceBoxSilkAndTrap selectionId={selectionId} />

                <JockeyAndTrainerDetails
                    isDetailsAvailable={isParticipantDescHidden === false}
                    selectionId={selectionId}
                    textTruncate={false}
                />
            </CellRunner>

            <SelectionWrapper
                borderLeft={true}
                selectionId={selectionId}
            />
        </>
    );
});
